import React from 'react'
import ReactDOM from 'react-dom/client'
import { initSentry } from '@/lib/sentry'
import { AppErrorBoundary } from '@/components/ErrorBoundary'
import App from '@/App.jsx'
import '@/index.css'

// Render first
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>
)

// Load Sentry after initial render
if (typeof requestIdleCallback === 'function') {
  requestIdleCallback(() => initSentry())
} else {
  setTimeout(() => initSentry(), 1000)
}
